import cssVars from 'css-vars-ponyfill'
import themeUtils from '../../util/themeUtils'

const customize = {
  state: {
    info: null
  },
  actions: {
    setCustomizeInfo (context, info) {
      const profile = info.profile
      if (profile) {
        context.commit('setProfile', profile)
      }
      const customize = info.customize
      if (customize) {
        const theme = customize.theme
        if (theme) {
          const color = theme.color
          if (color.value) {
            cssVars({
              variables: {
                '--theme-color': color.value
              },
              watch: true,
              onlyLegacy: false,
              silent: true
            })
            themeUtils.changeTheme(color.value)
          }
        }
      }
      context.state.info = info
    }
  }
}

export default customize
